export default __webpack_public_path__ + "a53411400d8962ca946b024e02c16d01.png";